<template>
  <section class="map-info">
    <v-login-info></v-login-info>

    <div class="form-content">
      <h1 class="map-title">地图MOD{{ setpText }}区信息</h1>
      <dl class="form-box clearfix">
        <dt class="title">地图ID：</dt>
        <dd class="content">{{ mapInfo.MapId }}</dd>
      </dl>

      <dl class="form-box clearfix">
        <dt class="title">地图名字：</dt>
        <dd class="content">
          <span class="name">{{ mapInfo.MapName }}</span>
        </dd>
      </dl>

      <dl class="form-box clearfix">
        <dt class="title">匹配模式：</dt>
        <dd class="content">
          <div>{{ tempInfo.teampeople }}排， {{ tempInfo.teamnummin }}队</div>
        </dd>
      </dl>

      <!--<dl class="form-box clearfix">
        <dt class="title">游戏状态：</dt>
        <dd class="content">
          <div>等等等</div>
          <div>等等等</div>
        </dd>
      </dl>-->

      <dl class="form-box clearfix">
        <dt class="title">游戏标签：</dt>
        <dd class="content">
          <span class="name">{{ mapInfo.MapTag }}</span>
        </dd>
      </dl>

      <dl class="form-box clearfix">
        <dt class="title">游戏介绍：</dt>
        <dd class="content">
          <span class="name">{{ mapInfo.Note }}</span>
        </dd>
      </dl>

      <dl class="form-box clearfix">
        <dt class="title">更新内容：</dt>
        <dd class="content">
          <span class="name">{{ mapInfo.UpdateContent }}</span>
        </dd>
      </dl>

      <dl class="form-box clearfix">
        <dt class="title">游戏主图：</dt>
        <dd class="content">
          <img class="game-main-image" :src="mapInfo.MainPicture ? mapInfo.MainPicture : defaultPic" alt="游戏主图"/>
        </dd>
      </dl>

      <dl class="form-box clearfix">
        <dt class="title">游戏截图：</dt>
        <dd class="content game-scree-image">
          <div class="item">
            <img class="image" v-show="mapInfo.Picture1" :src="mapInfo.Picture1" alt="截图截图"/>
          </div>
          <div class="item">
            <img class="image" v-show="mapInfo.Picture2" :src="mapInfo.Picture2" alt="截图截图"/>
          </div>
          <div class="item">
            <img class="image" v-show="mapInfo.Picture3" :src="mapInfo.Picture3" alt="截图截图"/>
          </div>
        </dd>
      </dl>

      <dl class="form-box clearfix">
        <dt class="title"></dt>
        <dd class="content game-scree-image">
          <div class="item">
            <img class="image" v-show="mapInfo.Picture4" :src="mapInfo.Picture4" alt="截图截图"/>
          </div>
          <div class="item">
            <img class="image" v-show="mapInfo.Picture5" :src="mapInfo.Picture5" alt="截图截图"/>
          </div>
          <div class="item"></div>
        </dd>
      </dl>

      <dl class="form-box clearfix">
        <dt class="title"></dt>
        <dd class="content">
          <p>发布时间：{{ createTime }}</p>
          <p>您的版本提交日期：{{ submitTime }}</p>
          <p>版本号：{{ mapInfo.MapVersion }}</p>
        </dd>
      </dl>
    </div>
  </section>
</template>

<script type="text/ecmascript-6">
  // 引入用户登录信息组件
  import loginInfo from 'components/loginInfo/loginInfo'
  // 图片上传组件
  import VueCoreImageUpload from 'vue-core-image-upload'
  // ajax 请求插件
  import Axios from 'axios'
  // 引入 cookie插件
  import VueCookie from 'vue-cookie'
  // 用户信息相关操作
  import {delUserCookie} from 'assets/js/user'
  // 遮罩提示层
  import basicMask from 'components/basicMask/basicMask'

  export default {
    // 测试区地图审核页面
    name: 'devMapinspect',
    data () {
      return {
        // 匹配模式
        tempInfo: '',
        // 创建时间
        createTime: '',
        // 提交时间
        submitTime: '',
        // 地图信息
        mapInfo: '',
        // 地图id
        mapId: this.$route.params.mapId,
        // 地图进行阶段
        stage: this.$route.params.stage,
        // 请求地图信息接口
        apiPath: '',
        // 表单数据
        formDatas: {
          // 用户id
          userId: VueCookie.get('UserID'),
          // session id
          sessionId: VueCookie.get('SessionID')
        },
        // 默认显示图片
        defaultPic: '/static/img/default-main-image.png'
      }
    },
    computed: {
      setpText () {
        switch (this.stage) {
          // 设置开发阶段的获取地图信息接口和撤销审核申请接口
          case 'dev':
            return '开发'
          // 设置测试阶段的获取地图信息接口和撤销审核申请接口
          case 'exa':
            return '测试'
          // 设置正式阶段的获取地图信息接口和撤销审核申请接口
          case 'pub':
            return '正式'
          default:
            return '未知'
        }
      }
    },
    created () {
      console.log(this.$route.params)
      this.init()
    },
    methods: {
      // 初始化数据
      init () {
        // 实例化表单对象
        let formData = new FormData()
        // 将用户名添加到表单
        formData.append('UserID', this.formDatas.userId)
        // 将密码添加到表单
        formData.append('SessionID', this.formDatas.sessionId)
        // 地图id
        formData.append('MapId', this.mapId)
        // 请求地图详细信息 api
        switch (this.stage) {
          // 设置开发阶段的获取地图信息接口和撤销审核申请接口
          case 'dev':
            this.apiPath = '/Developer/GetMapDevInfo'
            break
          // 设置测试阶段的获取地图信息接口和撤销审核申请接口
          case 'exa':
            this.apiPath = '/Developer/GetMapExaInfo'
            break
          // 设置正式阶段的获取地图信息接口和撤销审核申请接口
          case 'pub':
            this.apiPath = '/Developer/GetMapPubInfo'
            break
          default:
            console.log('开发阶段匹配错误')
        }
        // 请求地图详细信息 api
        Axios.post(`${this.$api.root}${this.apiPath}`, formData, {
          // 设置请求为表单提交
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((response) => {
          // http 请求成功
          if (response.status === 200) {
            // 获取接口数据
            let res = response.data
            switch (res.Code) {
              case 0:
                // 请求地图详细信息 api
                switch (this.stage) {
                  // 设置开发阶段的获取地图信息接口和撤销审核申请接口
                  case 'dev':
                    // 将地图信息赋值到对象属性
                    this.mapInfo = res.DevInfo
                    // 创建时间
                    this.createTime = res.CreateTime
                    // 提交时间
                    this.submitTime = res.SubmitTime
                    // 获取匹配模式
                    if (res.TeamList[0]) {
                      this.tempInfo = res.TeamList[0]
                    }
                    break
                  // 设置测试阶段的获取地图信息接口和撤销审核申请接口
                  case 'exa':
                    // 将地图信息赋值到对象属性
                    this.mapInfo = res.ExaInfo
                    // 创建时间
                    this.createTime = res.CreateTime
                    // 提交时间
                    this.submitTime = res.SubmitTime
                    // 获取匹配模式
                    if (res.TeamList[0]) {
                      this.tempInfo = res.TeamList[0]
                    }
                    break
                  // 设置正式阶段的获取地图信息接口和撤销审核申请接口
                  case 'pub':
                    // 获取匹配模式
                    this.tempInfo = res.TeamList
                    // 创建时间
                    this.createTime = res.CreateTime
                    // 提交时间
                    this.submitTime = res.SubmitTime
                    // 将地图信息赋值到对象属性
                    if (res.TeamList[0]) {
                      this.tempInfo = res.TeamList[0]
                    }
                    break
                  default:
                    console.log('开发阶段匹配错误')
                }
                break
              case 1:
                // 删除登录信息
                delUserCookie()
                this.$router.push({name: 'login'})
                break
              default:
                console.log(res.Code)
                console.log(res.Msg)
            }
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    components: {
      'v-login-info': loginInfo,
      'vue-core-image-upload': VueCoreImageUpload,
      'v-basic-mask': basicMask
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "mapShowStatus.styl";
</style>



// WEBPACK FOOTER //
// src/views/mapShowStatus/mapShowStatus.vue